export const safeJSONParse = (afterCacheString) => {
	try {
		return JSON.parse(afterCacheString);
	} catch (e) {
		return {};
	}
};
